export default __webpack_public_path__ + "static/media/playroom-breadcrumb-arrow.73d8746f.svg";